export function getMealCardTint(mealType) {
  if (mealType === "breakfast") return "rgba(251, 191, 36, 0.18)";
  if (mealType === "lunch") return "rgba(96, 165, 250, 0.18)";
  if (mealType === "dinner") return "rgba(139, 92, 246, 0.18)";
  return "rgba(255, 255, 255, 0.08)";
}

export function getMealCardBackground(meal, isFront = false) {
  if (meal?.image) {
    return `linear-gradient(to top, rgba(15,23,42,${isFront ? 0.88 : 0.82}), rgba(15,23,42,0.16)), url(${meal.image})`;
  }

  return isFront
    ? "linear-gradient(145deg, rgba(255,255,255,0.14), rgba(255,255,255,0.06))"
    : "linear-gradient(145deg, rgba(255,255,255,0.10), rgba(255,255,255,0.04))";
}

export function renderSettingsIcon(type) {
  const icons = {
    datahub: "📊",
    account: "👤",
    notifications: "🔔",
    privacy: "🔒",
    support: "💬",
    feedback: "✉️",
    signout: "🚪"
  };
  return icons[type] || "⚙️";
}

export function renderSettingsRow(appTheme, label, type, isDanger, onClick) {
  return (
    <button
      onClick={onClick}
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 16px",
        border: "none",
        background: "transparent",
        cursor: onClick ? "pointer" : "default",
        textAlign: "left"
      }}
    >
      <div style={{
        fontSize: "15px",
        fontWeight: "600",
        color: isDanger ? "#dc2626" : appTheme.primaryText
      }}>
        {label}
      </div>
      {onClick && (
        <div style={{ fontSize: "22px", color: isDanger ? "#f87171" : appTheme.mutedText }}>›</div>
      )}
    </button>
  );
}

export function renderSettingsInfoRow(appTheme, label, value) {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "14px 16px"
    }}>
      <div style={{ fontSize: "15px", fontWeight: "600", color: appTheme.primaryText }}>
        {label}
      </div>
      <div style={{ fontSize: "14px", color: appTheme.secondaryText }}>
        {value}
      </div>
    </div>
  );
}

export function renderSettingsToggleRow(appTheme, label, value, onToggle) {
  return (
    <button
      onClick={onToggle}
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 16px",
        border: "none",
        background: "transparent",
        cursor: "pointer",
        textAlign: "left"
      }}
    >
      <div style={{ fontSize: "15px", fontWeight: "600", color: appTheme.primaryText }}>
        {label}
      </div>
      <div style={{
        width: "44px",
        height: "26px",
        borderRadius: "999px",
        background: value === "On" ? appTheme.accentColor : appTheme.softBackground,
        border: value === "On" ? appTheme.accentBorder : appTheme.pillBorder,
        position: "relative",
        transition: "all 0.22s ease",
        flexShrink: 0
      }}>
        <div style={{
          position: "absolute",
          top: "3px",
          left: "3px",
          transform: value === "On" ? "translateX(18px)" : "translateX(0)",
          width: "20px",
          height: "20px",
          borderRadius: "999px",
          background: "#ffffff",
          boxShadow: "0 2px 6px rgba(15,23,42,0.18)",
          transition: "transform 0.22s ease"
        }} />
      </div>
    </button>
  );
}